import { ChecklistItemTypeEnum } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const ChecklistItemCreateUpdateSchema = z.object({
  label: z.string().min(1).max(500),
  description: z.string().nullable().optional(),
  type: z.enum(ChecklistItemTypeEnum),
  isRequired: z.boolean(),
  order: z.number().int().min(0),
});

export const InspectionChecklistCreateUpdateSchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().nullable().optional(),
  items: z.array(ChecklistItemCreateUpdateSchema),
});

export class ChecklistItemCreateUpdateDto extends createZodDto(
  ChecklistItemCreateUpdateSchema,
) {}

export class InspectionChecklistCreateUpdateDto extends createZodDto(
  InspectionChecklistCreateUpdateSchema,
) {}
